import { render, staticRenderFns } from "./WorkEducation.vue?vue&type=template&id=fcd85a0c&"
import script from "./WorkEducation.vue?vue&type=script&lang=js&"
export * from "./WorkEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports